import { countOccurrences } from '../countOccurences'
import { isZipCode } from '../isZipCode'

export const isCounty = (slug: string): boolean => {
  return slug.includes('-county-') && (countOccurrences(slug, '-') >= 2) && !isZipCode(slug)
}
